import { assetTypeMap } from "../../leases/components/LeaseConstants";

export const getReDeliveryConditionApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/re-delivery${queryString ? `?${queryString}` : ""}`;
};

export const getReDeliveryConditionContractualApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/contractual${queryString ? `?${queryString}` : ""}`;
};


export const editReDeliveryConditionApi = (params) => {
    return `/lease/${params?.leaseSlug}/re-delivery`;
}

export const  getAssemblysList=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies?delivery_assembly_type=re-delivery`
}

export const  getMaintenanceListAPI=(params)=>{
    return `config/maintenance-checks/${assetTypeMap[params?.asset?.asset_type]}/${params?.asset?.id}/`
}

export const  addAssemblysApi=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies?delivery_assembly_type=re-delivery`
}

export const  updateAssemblysApi=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}?delivery_assembly_type=re-delivery`
}
export const  addAssemblysEventApi=(params)=>{
    return `/lease/${params?.params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}/maintenance_events`
}

export const  updateAssemblysEventApi=(params)=>{
    return `/lease/${params?.params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}/maintenance_events/${params?.event_slug}`
}

export const  deleteAssemblysEventApi=(params)=>{
    return `/lease/${params?.params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}/maintenance_events`
}

export const  deleteAssemblysApi=(params)=>{
    return `/lease/${params?.params?.leaseSlug}/delivery-assemblies`
}

export const  addAssemblysActulConfigApi=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies?delivery_assembly_type=actual-config`
}

export const getClauseAPi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/condition_clause${queryString ? `?${queryString}` : ""}`;
};